module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/logo-一级导航栏.11cb2.png";